import Confirm from 'assets/components/page/templates/Confirm';
import ThemeConfirmDefault from 'assets/components/page/templates/themes/Theme.Confirm.Default';
import { getLocales } from 'assets/locales/Locale';
import React from 'react';
import { useStatementProvider } from '../Statement.Hooks';

export default function StatementDelete() {
  const { lang } = getLocales();
  const { deleteApi, selected, pageRouter } = useStatementProvider();

  return (
    <Confirm
      data={selected}
      onConfirm={({ id }) => deleteApi.execute(id)}
      onClose={pageRouter.updateParams}
      actionName={lang.delete}
      itemName={selected.displayInfo.title}
      confirmationType="nextButton"
      subcomponents={ThemeConfirmDefault}
    />
  );
}
